import { toast } from "sonner";
import { AjudaPopover, Dialog, DialogContent } from "@bookdental/ui";
import { trpc } from "@/lib/trpc";
import { AJUDA_ONBOARDING } from "@/lib/ajuda/dialogos/onboarding";
import { OnboardingWizard } from "@/components/onboarding/OnboardingWizard";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  initialName?: string;
  initialPhone?: string;
};

/** Reabre o wizard de onboarding sob demanda pra quem nunca ganhou organização pessoal (ex: entrou
 *  via convite de equipe) — ver "Criar minha conta pessoal" em CreatePersonalOrgSection.tsx. */
export function CreatePersonalOrgDialog({ open, onOpenChange, initialName, initialPhone }: Props) {
  const utils = trpc.useUtils();

  const handleComplete = () => {
    utils.me.current.invalidate();
    utils.organization.listMine.invalidate();
    toast.success("Conta pessoal criada.");
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="flex max-h-[92vh] w-full max-w-3xl flex-col gap-0 overflow-hidden p-0 sm:rounded-3xl">
        <div className="flex-1 overflow-y-auto p-6 sm:p-10">
          <OnboardingWizard
            onComplete={handleComplete}
            onCancel={() => onOpenChange(false)}
            initialName={initialName}
            initialPhone={initialPhone}
          />
        </div>
        {/* O título é do wizard; o "?" fica no canto, à esquerda do X (que ocupa 44px). */}
        <AjudaPopover className="absolute right-12 top-2.5">{AJUDA_ONBOARDING.contaPessoal}</AjudaPopover>
      </DialogContent>
    </Dialog>
  );
}
